import { Injectable } from '@angular/core';
import { PersistenceService, StorageType } from 'angular-persistence';
import { Observable } from "rxjs/Observable";
import { HttpClient } from "@angular/common/http";
import { Router } from '@angular/router';
import { MessageService } from 'primeng/components/common/messageservice';
import { Constant } from '../../infrastructure/constant';
import { User } from '../../models/user.model';
import { BaseService } from '../base.service';
import { environment } from '../../../environments/environment';
import { HttpParams } from '@angular/common/http';
import { ResponseModel } from '../../models';

@Injectable()
export class AuthService extends BaseService{

  constructor(protected messageService: MessageService, protected persistenceService: PersistenceService, protected httpClient: HttpClient, private router: Router) {
    super(messageService, httpClient, persistenceService, environment.apiGeneralUrl, "Account");
  }

  userName:string;
  public isLoggedIn(): boolean {
    var isLogged = this.persistenceService.get(Constant.auths.isLoginIn, StorageType.LOCAL);
    if (isLogged === 'true') {
      return true;
    }
    return false;
  }

  async login(userName: string, password: string, hourLogin: number, minuteLogin: number): Promise<ResponseModel> {
    var loginObj = new Object();
    loginObj["UserName"] = userName;
    loginObj["PassWord"] = password;
    loginObj["HourLogin"] = hourLogin;
    loginObj["MinuteLogin"] = minuteLogin;
    this.userName = userName;
    let ret = await super.postCustomApi("SignIn", loginObj).toPromise();
    return ret;
  }

  public getEmpByCode(userName: string) {
    let params = new HttpParams();
    params = params.append("username", userName);
    return super.getCustomApi("GetEmpByCode", params);
  }

  public logout() {
    this.persistenceService.remove(Constant.auths.isLoginIn, StorageType.LOCAL);
    this.persistenceService.remove(Constant.auths.token, StorageType.LOCAL);
    this.persistenceService.remove(Constant.auths.userId, StorageType.LOCAL);
    this.persistenceService.remove(Constant.auths.userName, StorageType.LOCAL);
    this.persistenceService.remove(Constant.auths.fullName, StorageType.LOCAL);
    this.persistenceService.remove(Constant.auths.datetimeLogin, StorageType.LOCAL);
    var routing = Constant.pages.login.alias;
    this.userName ="";
    this.router.navigate([routing]);
  }

  public getToken(): string {
    return this.persistenceService.get(Constant.auths.token, StorageType.LOCAL);
  }

  public getUserId(): number {
    return this.persistenceService.get(Constant.auths.userId, StorageType.LOCAL);
  }

  public getUserName(): string {
    return this.persistenceService.get(Constant.auths.userName, StorageType.LOCAL);
  }

  public getFullName(): string {
    return this.persistenceService.get(Constant.auths.fullName, StorageType.LOCAL);
  }

  public getAccountInfo() {
    let cols = [Constant.classes.includes.user.hub, Constant.classes.includes.user.role, Constant.classes.includes.user.department];

    let id = this.persistenceService.get(Constant.auths.userId, StorageType.LOCAL);

    let params = new HttpParams();
    params = params.append("id", id);

    return super.getCustomApiPaging("get", cols, params);
  }

  public async getAccountInfoAsync(): Promise<User> {
    const res = await this.getAccountInfo().toPromise();
    if (res.isSuccess) {
      const data = res.data as User;
      return data;
    } else {
      return new User();
    }
  }

  public UpdateSeriNumber(seriNumber: any) {
    var loginObj = new Object();
    loginObj["seriNumber"] = seriNumber;

    return super.postCustomApi("UpdateSeriNumber", loginObj);
  }

  async requestPrintInWinform(connectCode: string, shipmentIds: any[]): Promise<ResponseModel> {
    var model = new Object();
    model["ConnectCode"] = connectCode;
    model["Token"] = this.getToken();
    model["ShipmentIds"] = shipmentIds;

    let ret = await super.postCustomApi("RequestPrintInWinform", model).toPromise();
    return ret;
  }

  async requestInputWarehouse(hubId: any): Promise<ResponseModel> {
    var model = new Object();
    model["hubId"] = hubId;

    let ret = await super.postCustomApi("RequestInputWarehouse", model).toPromise();
    return ret;
  }
  async requestOutWarehouse(hubId: any): Promise<ResponseModel> {
    var model = new Object();
    model["hubId"] = hubId;

    let ret = await super.postCustomApi("RequestOutputWarehouse", model).toPromise();
    return ret;
  }
  async checkHourShift(userId: number, hourLogin: number, minuteLogin: number) {
    var model = new Object();
    model["UserId"] = userId;
    model["HourLogin"] = hourLogin;
    model["MinuteLogin"] = minuteLogin;
    super.postCustomApi("CheckHourShift", model).toPromise().then(
      x => {
        if (!x.isSuccess) this.logout();
      }
    )
  }
  async getById(id: any): Promise<User> {
    let cols = [Constant.classes.includes.user.hub, Constant.classes.includes.user.role, Constant.classes.includes.user.department];
    let params = new HttpParams();
    params = params.append("id", id);
    let res = await super.getCustomApi("get", params).toPromise();
    if (!this.isValidResponse(res)) return;
    return res.data;
  }

  async updateUser(model:any){
    const res = await super.postCustomApi("update",model).toPromise();
    if(!this.isValidResponse(res))return;
    return res.data;
  }
}
